import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { BUSINESS } from "../config";

const LINKS = [
  { label: "Services", href: "#services" },
  { label: "Marketplace", href: "#marketplace" },
  { label: "Service Area", href: "#area" },
  { label: "Gallery", href: "#gallery" },
  { label: "Donations", href: "#donations" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href) => {
    setOpen(false);
    if (href.startsWith("#")) {
      document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
    } else navigate(href);
  };

  return (
    <header
      data-testid="main-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${scrolled ? "bg-[#050505]/85 backdrop-blur-md border-b border-[var(--border-dim)]" : "bg-transparent"}`}
    >
      <div className="max-w-[1600px] mx-auto px-5 md:px-10 h-20 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="font-display font-black text-xl md:text-2xl uppercase tracking-tight leading-none">
          Austin<span className="text-[var(--accent)]">/</span>Abatement
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {LINKS.map((l) => (
            <button
              key={l.href}
              data-testid={`nav-${l.label.toLowerCase().replace(" ", "-")}`}
              onClick={() => go(l.href)}
              className="font-mono text-xs uppercase tracking-[0.15em] text-[var(--text-secondary)] hover:text-[var(--text-primary)] transition-colors"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            data-testid="nav-cta-bid"
            onClick={() => go("#bid")}
            className="hidden sm:inline-flex items-center gap-2 btn-wipe border border-[var(--accent)] text-[var(--accent)] hover:text-white px-5 py-2.5 font-mono text-xs uppercase tracking-widest"
          >
            Get a Bid <ArrowUpRight size={14} />
          </button>
          <button data-testid="nav-menu-toggle" onClick={() => setOpen((o) => !o)} className="lg:hidden p-2 text-[var(--text-primary)]">
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-[#050505] border-t border-[var(--border-dim)] px-5 py-6 flex flex-col gap-4">
          {LINKS.map((l) => (
            <button key={l.href} data-testid={`nav-mobile-${l.label.toLowerCase().replace(" ", "-")}`} onClick={() => go(l.href)} className="text-left font-display text-2xl uppercase font-bold">
              {l.label}
            </button>
          ))}
          <a href={`tel:${BUSINESS.phoneRaw}`} className="font-mono text-sm text-[var(--accent)] mt-2">{BUSINESS.phone}</a>
        </div>
      )}
    </header>
  );
}
